import { css } from '@emotion/react';
import { SectionTitle } from '@/components/general/SectionTitle';
import { PlanContentSection } from '@/components/plan/PlanContentSection';
import { ButtonLink } from '@/components/shared/ButtonLink';
import { DLBanner } from '@/components/general/DLBanner';
import { pagesPath } from '@/lib/pagesPath';
import { getScreen } from '@/styles/media-query';
import { Link, withPrefix } from 'gatsby';


export type PlanSectionProps = {
  className?: string;
};

export const PlanSection: React.FC<PlanSectionProps> = ({ className }) => {
  return (
    <section
      css={css`
        padding: 80px 30px;

        @media ${getScreen('pc')} {
          padding: 120px 20px 108px;
          background: linear-gradient(180deg, #ffffff00 0%, #ffffff 100%)
            #f0fcfb;
        }
      `}
      className={className}
    >
      <SectionTitle en="PRICE">
        <strong>料金プラン</strong>
      </SectionTitle>
      <PlanContentSection
        css={css`
          margin-top: 48px;

          @media ${getScreen('pc')} {
            margin-top: 60px;
          }
        `}
      />
      <ButtonLink
        css={css`
          margin: 64px 10px 0;

          @media ${getScreen('pc')} {
            margin: 80px auto 0;
            width: 221px;
          }
        `}
        to={pagesPath.plan.$url()}
        variant="top-more"
      >
        詳しく見る
      </ButtonLink>
      
      <DLBanner />
      
    </section>
  );
};
